<div
  class="history-mode-toggle d-flex flex-column justify-content-center p-2"
  placement="top"
  ngbTooltip="Show history mode"
  tooltipClass="custom-tooltip"
  [openDelay]="1000"
>
  <span
    class="rb-ic rb-ic-history fs-2xl ps-2 ho-layer-text"
    [class.sel-menu-item]="isHistoryVisible"
    (click)="historyToggled.emit()"
    data-cy="history-mode-toggle"
  ></span>
</div>
